export const ZIP_CODE_EMPTY = 'zipCodeEmpty';
export const ZIP_CODE_EMPTY_CODE = '001';
export const SERVICE_FAILED = 'serviceFailed';
export const SERVICE_FAILED_CODE = 'CARTS-011';
export const TAXES_NOT_FOUND = 'taxesNotFound';
export const TAXES_NOT_FOUND_CODE = 'CARTS-012';
export const apiErrorCodeConstantMap = {
  '001': ZIP_CODE_EMPTY,
  'CARTS-011': SERVICE_FAILED,
  'CARTS-012': TAXES_NOT_FOUND,
};
